module.exports = __webpack_public_path__ + "static/img/2.641d899.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/eng/2.png
// module id = 8gqZ
// module chunks = 0